import { Button, ButtonProps } from "../Button";
import styles from "./DialogButton.module.scss";

export const DialogButton = (props: ButtonProps) => (
  <div className={`button-group__item ${styles.buttonGroupItem}`}>
    <Button {...props} />
  </div>
);
